import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { API_PREFIX, BASE_URL } from '@CONSTANTS/API.constant';
import userRepository from '@REPOSITORIES/local-repository/user-repository';
import { DocumentSettings } from './app-settings.api';

export const documentSettingsApi = createApi({
    reducerPath: 'document-settings-api',
    baseQuery: fetchBaseQuery({
        baseUrl: BASE_URL + API_PREFIX,
        prepareHeaders: (headers) => {
            const token = userRepository.getData();

            if (token) {
                headers.set('Authorization', `Bearer ${token}`);
            }

            return headers;
        },
    }),
    tagTypes: ['DocumentSettings'],
    endpoints: (builder) => ({
        getDocumentSettings: builder.query<DocumentSettings, void>({
            query: () => ({
                url: '/document-settings/',
                method: 'GET',
            }),
            providesTags: ['DocumentSettings'],
        }),
    }),
});

export const {
    useGetDocumentSettingsQuery,
} = documentSettingsApi; 